export const formatDate = (dateString) => {
  const date = new Date(dateString)
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date)
}

export const formatDate_dd_mm_yyyy = (dateString) => {
  if (!dateString) return null
  const d = new Date(dateString)
  const day = String(d.getDate()).padStart(2, '0')
  const month = String(d.getMonth() + 1).padStart(2, '0') // Months are 0-indexed
  const year = d.getFullYear()
  return `${day}-${month}-${year}`
}
